import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class Search extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Serch',
    refs: ['open', 'close', 'block'],
  };

  // eslint-disable-next-line no-empty-function
  mounted() {}

  /**
   * Click trigger open search
   * @param {Event} e
   */
  onOpenClick(e) {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }

    this.$refs.block.classList.remove('m:-translate-y-full');

    const input = this.$refs.block.querySelector('input');
    if (input) input.focus();
  }

  /**
   * Click trigger close search
   * @param {Event} e
   */
  onCloseClick(e) {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }

    this.$refs.block.classList.add('m:-translate-y-full');
  }
}
